// Canonical vendor_status vocabulary shared by the vendor/material forms and
// lists. Keep in sync with the backend normalizer
// (nucleus-backend/app/helpers/normalize_vendor_status.js) — these values are
// what the backend stores and what the vendor reports filter on.
export const VENDOR_STATUS_OPTIONS = [
  { value: 'pending', label: 'Pending' },
  { value: 'approved', label: 'Approved' },
  { value: 'partially_approved', label: 'Partially Approved' },
  { value: 'provisional_approved', label: 'Provisional Approved' },
  { value: 'jubilant_approved', label: 'Jubilant Approved' },
  { value: 'blocked', label: 'Blocked' },
  { value: 'under_evaluation', label: 'Under Evaluation' },
  { value: 'disqualified', label: 'Disqualified' }
];

// Human-readable label for a stored vendor_status value. Falls back to the
// upper-cased raw value so legacy/unknown values still render something.
export const vendorStatusLabel = (value) =>
  VENDOR_STATUS_OPTIONS.find((opt) => opt.value === value)?.label ||
  (value ? String(value).toUpperCase() : '');
